import { isRole, ROLE_IMPLICATIONS, type Role } from "./roles";
import { ROLE_CAPABILITIES, type Capability } from "./capabilities";

export function expandRoles(roles: readonly string[]): Set<Role> {
  const out = new Set<Role>();
  const visit = (r: Role) => {
    if (out.has(r)) return;
    out.add(r);
    for (const implied of ROLE_IMPLICATIONS[r]) visit(implied);
  };
  for (const r of roles) if (isRole(r)) visit(r);
  return out;
}

export function capabilitiesForRoles(
  roles: readonly string[],
): Set<Capability> {
  const out = new Set<Capability>();
  for (const r of roles) {
    if (isRole(r)) {
      for (const cap of ROLE_CAPABILITIES[r]) out.add(cap);
    }
  }
  return out;
}
